export const getCookie = (name: string): string | undefined => {
  const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const match = document.cookie.match(new RegExp(`(?:^|; )${escapedName}=([^;]*)`));

  return match ? decodeURIComponent(match[1]) : undefined;
};

export const setCookie = (name: string, value: string, maxAgeInSeconds = 60 * 60 * 24 * 365) => {
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeInSeconds}; samesite=lax`;
};

export const replaceOrgInPath = (pathName: string, organizationName: string) => {
  const pathSegments = pathName.split('/').filter(Boolean);

  if (pathSegments.length === 0) {
    return `/${organizationName}`;
  }

  pathSegments[0] = organizationName;
  return `/${pathSegments.join('/')}`;
};

const SESSION_RETURN_URL_COOKIE = 'dm_session_return_url';
const RETURN_URL_COOKIE_TTL = 300;

export function saveReturnUrlCookie(): void {
  const returnPath = window.location.pathname + window.location.search + window.location.hash;
  setCookie(SESSION_RETURN_URL_COOKIE, returnPath, RETURN_URL_COOKIE_TTL);
}

export function consumeReturnUrlCookie(): string | undefined {
  const value = getCookie(SESSION_RETURN_URL_COOKIE);
  if (value) {
    setCookie(SESSION_RETURN_URL_COOKIE, '', 0);
  }
  return value;
}

export function getUrlReturnFromLocation(): string {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}
